import api from '@/api';

import { API_BASE_URL } from '..';
import {
  MatrixCustomerSettingsCreateRequest,
  MatrixCustomerSettingsEditRequest,
  MatrixCustomerSettingsResponse,
} from './MatrixCustomerSettings.types';

const CONTROLLER_URL = `${API_BASE_URL}/matrix-customer-settings`;

export async function getMatrixCustomerSettings() {
  const result = (await api.get(CONTROLLER_URL, {})) as unknown;

  return result as MatrixCustomerSettingsResponse;
}

export async function createMatrixCustomerSettings(
  obj: MatrixCustomerSettingsCreateRequest,
) {
  const result = (await api.post(CONTROLLER_URL, obj, null)) as unknown;

  return result;
}

export async function updateMatrixCustomerSettings(
  obj: MatrixCustomerSettingsEditRequest,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result;
}
